<template>
    <v-container>
        <v-card class="elevation-0">
            <v-card-title class="justify-center"><H4 class="font-weight-bold">興建中社宅施工進度</H4></v-card-title>
            <v-card-text>
                <apexchart :options="chartOptions" :series="series" height="280"></apexchart>
            </v-card-text>
            <v-card-actions class="justify-center mt-10"><span style="font-size: 16px">預定進度 {{(house.RT_EXPPRG != null)? house.RT_EXPPRG : 0}} %</span>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name : "SemiCircleGauge",
    props: {
        house: {}
    },
    data : function () {
        return {
            series      : [(this.house.RT_ACTPRG === null) ? 0 : this.house.RT_ACTPRG],
            // TODO : SemiCircleGauge 在手機小尺寸時寬度會被切掉
            chartOptions: {
                labels     : ["實際進度"],
                colors     : [(this.house.RT_ACTPRG >= this.house.RT_EXPPRG) ? '#82be3a' : '#fb7813'],
                chart      : {
                    type: 'radialBar',
                    // offsetY: -20,
                    sparkline: {
                        enabled: true
                    },
                    // background: '#ef1212',
                    // dropShadow: {
                    //     enabled: true,
                    //     enabledOnSeries: undefined,
                    //     top: 0,
                    //     left: 0,
                    //     blur: 3,
                    //     color: '#000',
                    //     opacity: 0.35
                    // },
                },
                legend     : {
                    show    : false,
                    position: 'bottom',
                    offsetY : 10,
                },
                plotOptions: {
                    radialBar: {
                        hollow    : {
                            // size: '50%',
                        },
                        endAngle  : 90,
                        startAngle: -90,
                        dataLabels: {
                            name : {
                                show: true
                            },
                            value: {
                                offsetY : -50,
                                fontSize: "16px"
                            }
                        },
                        // track     : {
                        //     background : "#e7e7e7",
                        //     strokeWidth: "97%",
                        //     margin     : 5 // margin is in pixels
                        // },
                    }
                },
                // fill: {
                //     colors: "#fffff",
                //     opacity: 0.9,
                //     type: 'solid',
                //     gradient: {
                //         shade: 'dark',
                //         type: "horizontal",
                //         shadeIntensity: 0.5,
                //         gradientToColors: undefined,
                //         inverseColors: true,
                //         opacityFrom: 1,
                //         opacityTo: 1,
                //         stops: [0, 50, 100],
                //         colorStops: []
                //     },
                //     image: {
                //         src: [],
                //         width: undefined,
                //         height: undefined
                //     },
                //     pattern: {
                //         style: 'verticalLines',
                //         width: 6,
                //         height: 6,
                //         strokeWidth: 2,
                //     },
                // },
                noData     : {
                    text         : "目前尚無資料",
                    align        : 'center',
                    verticalAlign: 'middle',
                    offsetX      : 0,
                    offsetY      : 0,
                    style        : {
                        color     : undefined,
                        fontSize  : '16px',
                        fontFamily: undefined
                    }
                }
            }
        }
    },
    // https://stackoverflow.com/questions/42722433/accessing-props-in-vue-component-data-function
    // data : () => ({
    //     series      : [76],
    //     chartOptions: {
    //         labels     : ["實際進度"],
    //         chart      : {
    //             type   : "radialBar",
    //             offsetY: 30,
    //             // sparkline: {
    //             //     enabled: true
    //             // }
    //         },
    //         plotOptions: {
    //             radialBar: {
    //                 hollow    : {
    //                     size: '65%',
    //                 },
    //                 startAngle: -90,
    //                 endAngle  : 90,
    //                 track     : {
    //                     // background : "#e7e7e7",
    //                     // strokeWidth: "97%",
    //                     // margin     : 5 // margin is in pixels
    //                 },
    //                 dataLabels: {
    //                     name : {
    //                         show: true
    //                     },
    //                     value: {
    //                         offsetY : -50,
    //                         fontSize: "22px"
    //                     }
    //                 }
    //             }
    //         },
    //         grid       : {
    //             padding: {
    //                 top: -10
    //             }
    //         }
    //     }
    // }),
    created() {
        // console.log(this.house);
    },
    components: {},
    computed  : {},
    methods   : {}
};
</script>
